import { render, staticRenderFns } from "./BuildingIcon.vue?vue&type=template&id=12928df9&"
import script from "./BuildingIcon.vue?vue&type=script&lang=ts&"
export * from "./BuildingIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports